export interface CustomersFilter {
  readonly search?: string;
  readonly business_area?: string;
  readonly responsible_id?: string;
  readonly created_at_from?: string;
  readonly created_at_to?: string;
}

export const defaultCustomersFilterFields: CustomersFilter = {
  search: "",
  business_area: "",
  responsible_id: undefined,
  created_at_from: "",
  created_at_to: "",
} as const;
